import { Component, HostBinding } from '@angular/core';
import { translate } from '@ngneat/transloco';
import {
  FieldType,
  FormlyExtension,
  FormlyFieldConfig
} from '@ngx-formly/core';
import { countryOptions } from '@tpa/features/emp-data';
import { tap } from 'rxjs/operators';
import { sharedQuestion } from '../../form-parts-definition';

@Component({
  selector: 'tpa-rezidentura-2026',
  templateUrl: './rezidentura-2026.component.html',
  // TODO: TPA : Uncomment this
  // host: { class: 'tpa-wrapper__control' },
})
export class Rezidentura2026Component extends FieldType implements FormlyExtension {
  defaultOptions = {
    className: 'p-col-12',
    props: {
      translate: true,
      open: false,
    },
  };

  @HostBinding('class.p-grid') someField = true;

  onPopulate(field: FormlyFieldConfig) {
    if (field.fieldGroup) {
      return;
    }

    field.fieldGroup = [
      // {
      //   template: `
      //     <h3 class="h4">${translate('TPA.ResidentureQ1')}</h3>
      //     <p class="description">${translate('TPA.ResidentureQ1Desc')}</p>
      //   `,
      // },
      // {
      //   key: 'zdrzovaniVCR',
      //   type: 'yes-or-no',
      //   className: 'p-col-12',
      //   props: {
      //     required: true,
      //     translate: true,
      //     yesText: 'TPA.Yes',
      //     noText: 'TPA.No',
      //   },
      //   expressionProperties: {
      //     'props.disabled': (m, formState, field) => {
      //       return field?.model?.rezidentura != null;
      //     },
      //   },
      // },
      {
        ...sharedQuestion({
          key: 'zdrzovaniVCR',
          className: 'p-col-12',
          props: {
            required: true,
            translate: true,
            label: 'TPA.ResidentureQ1',
            description: 'TPA.ResidentureQ1Desc',
            yesText: 'TPA.Yes',
            noText: 'TPA.No',
          },
          // Hide auto-eval questions when personal part is locked and the
          // required personal data is missing — the user picks residency
          // manually instead. See step-4-residency.component.ts for the
          // matching logic.
          hideExpression: (m, formState) =>
            !!formState?.disablePersonalPart &&
            !!formState?.isResidencyDataMissing?.(),
          expressionProperties: {
            'props.disabled': (m, formState, field) => {
              return field?.model?.rezidentura != null;
            },
          },
        })
      },
      // {
      //   template: `
      //   <h3 class="h4">${translate('TPA.ResidentureQ2')}</h3>
      //     <p class="description">${translate('TPA.ResidentureQ2Desc')}</p>
      //   `,
      //   hideExpression:
      //     /* '(model?.prvniZamestnaniVCR == null || (model?.studiumVCR == null && model?.rezidentura != null))', */
      //     '(model?.zdrzovaniVCR == null || (model?.studiumVCR == null && model?.rezidentura != null))',
      // },
      // {
      //   key: 'studiumVCR',
      //   type: 'yes-or-no',
      //   className: 'p-col-12',
      //   props: {
      //     required: true,
      //     translate: true,
      //     yesText: 'TPA.Yes',
      //     noText: 'TPA.No',
      //     // change: (field) => {
      //     //   field.parent.fieldGroup?//   .find((p) => p.key == 'rezidentura')?//   .formControl?.patchValue("cz");
      //     // },
      //   },
      //   hideExpression:
      //     /* '(model?.prvniZamestnaniVCR == null || (model?.studiumVCR == null && model?.rezidentura != null))', */
      //     '(model?.zdrzovaniVCR == null || (model?.studiumVCR == null && model?.rezidentura != null))',
      //   expressionProperties: {
      //     'props.disabled': (m, formState, field) =>
      //       field?.model?.rezidentura != null,
      //   },
      // },
      {
        ...sharedQuestion({
          key: 'studiumVCR',
          props: {
            label: 'TPA.ResidentureQ2',
            description: 'TPA.ResidentureQ2Desc',
            required: true,
            translate: true,
            yesText: 'TPA.Yes',
            noText: 'TPA.No',
          },
          hideExpression: (m, formState) =>
            (!!formState?.disablePersonalPart &&
              !!formState?.isResidencyDataMissing?.()) ||
            m?.zdrzovaniVCR == null ||
            (m?.studiumVCR == null && m?.rezidentura != null),
          expressionProperties: {
            'props.disabled': (m, formState, field) =>
              field?.model?.rezidentura != null,
          },
        })
      },
      {
        className: 'p-col-12',
        template: `
          <h3 class="h4">${translate('TPA.Evaluation')}</h3>
          <p class="">${translate('TPA.EvaluationN')}</p>
        `,
        hideExpression: '(model?.rezidenturaVyhodnoceni != "false")',
      },
      {
        className: 'p-col-12',
        template: `
          <h3 class="h4">${translate('TPA.Evaluation')}</h3>
          <p class="">${translate('TPA.EvaluationR')}</p>
        `,
        hideExpression: '(model?.rezidenturaVyhodnoceni != "true")',
      },

      {
        key: 'rezidenturaVyhodnoceni',
        type: 'select',
        className: 'p-col-12 p-md-6',
        props: {
          placeholder: 'TPA.SelectPlaceholder',
          translate: true,
          translateOptions: true,
          options: [
            { label: 'TPA.Rezident', value: 'true' },
            { label: 'TPA.Nerezident', value: 'false' },
          ],
          label: 'TPA.ResidentureRecognition',
        },
        hideExpression: true,
      },
      {
        key: 'rezidentura',
        type: 'select',
        className: 'p-col-12 p-xl',
        props: {
          required: true,
          translate: true,
          translateOptions: true,
          placeholder: 'TPA.SelectPlaceholder',
          options: [
            { label: 'TPA.Rezident', value: 'true' },
            { label: 'TPA.Nerezident', value: 'false' },
          ],
          label: 'TPA.ResidentureDeclaration',
        },
        // In manual-fallback mode reveal the picker even when rezidentura is
        // null, since auto-eval cannot fill it.
        hideExpression: (m, formState) =>
          m?.rezidentura == null &&
          !(
            !!formState?.disablePersonalPart &&
            !!formState?.isResidencyDataMissing?.()
          ),
        // Re-run the sibling rezidenturaVeState validator
        // (validateNonRezidentHasToBeOutsideCzech) whenever rezidentura
        // changes — Angular won't otherwise notice the cross-field
        // invariant flipped. See step-4-residency.component.ts for the
        // matching hook (and emp.validations.ts for the timing details
        // that make the Promise.resolve() defer necessary).
        hooks: {
          onInit: (field) =>
            field?.formControl?.valueChanges.pipe(
              tap(() => {
                Promise.resolve().then(() => {
                  field?.parent?.fieldGroup
                    ?.find((p) => p.key === 'rezidenturaVeState')
                    ?.formControl?.updateValueAndValidity({ emitEvent: false });
                });
              })
            ),
        },
      },
      {
        key: 'rezidenturaVeState',
        type: 'select',
        className: 'p-col',
        props: {
          required: true,
          placeholder: 'TPA.SelectPlaceholder',
          translate: true,
          translateOptions: true,
          options: [...countryOptions()],
          label: 'TPA.ResidentureCountry',
        },
        validators: {
          validation: [{ name: 'validateNonRezidentHasToBeOutsideCzech' }],
        },
        hideExpression:
          '(model?.rezidentura == null) || (model?.rezidentura == "true")',
      },


      {
        key: 'typDanoveIdentifikace',
        type: 'select',
        className: 'p-col-12',
        props: {
          label: 'TPA.ResidentureIdentificationType',
          required: true,
          translate: true,
          // infoTooltip: 'TPA.ResidentureIdentificationInfo',
          placeholder: 'TPA.SelectPlaceholder',
          options: [
            { label: translate('TPA.ResidencyIdentificationType.VAT'), value: 'D' },
            { label: translate('TPA.ResidencyIdentificationType.BirthNumber'), value: 'R' },
            { label: translate('TPA.ResidencyIdentificationType.SocialSecurityNumber'), value: 'S' },
            { label: translate('TPA.ResidencyIdentificationType.Other'), value: 'J' },
          ],
        },
        hideExpression: '(model?.rezidenturaVeState == null) || (model?.rezidenturaVeState == "CZ" || model?.rezidentura === "true") ',
        expressions: {
          "props.required": (field) => {
            return !(field.model?.rezidentura !== 'false'
              || !field.parent?.model?.rezidenturaVeState
              || field.parent?.model?.rezidenturaVeState === 'CZ');
          }
        }
      },
      {
        className: 'p-col-12',
        template: `
          <p class="mb-1">
          ${translate('TPA.EUCountry')} <a href="${translate('TPA.EUCountryLink')}" target="_blank" rel="noopener noreferrer">${translate('TPA.EUCountryLink')}</a>
          </p>
          <p class="mb-1">
          ${translate('TPA.OECDCountry')} <a href="${translate('TPA.OECDCountryLink')}" target="_blank" rel="noopener noreferrer">${translate('TPA.OECDCountryLink')}</a>
          </p>
        `,
        hideExpression:
          '(model?.rezidenturaVyhodnoceni == null) || (model?.rezidentura != "false")',
      },
      {
        key: 'identifikace',
        type: 'input',
        className: 'p-col-12',
        props: {
          label: 'TPA.ResidentureIdentification',
          translate: true,
        },
        hideExpression:
          '(model?.rezidenturaVeState == null) || (model?.rezidenturaVeState == "CZ" || model?.rezidentura === "true") ',
        expressions: {
          "props.required": (field) => {
            return !(field.model?.rezidentura !== 'false'
              || !field.parent?.model?.rezidenturaVeState
              || field.parent?.model?.rezidenturaVeState === 'CZ');
          }
        }
      },
      {
        className: 'p-col-12',
        template: `
          <p class="font-bold">${translate('TPA.RezidentInfo')}</p>
        `,
        hideExpression:
          '(model?.rezidenturaVyhodnoceni == null) || (model?.rezidentura != "true")',
      },
      {
        className: 'p-col-12',
        template: `
          <p class="font-bold">${translate('TPA.NerezidentInfo')}</p>
        `,
        hideExpression:
          '(model?.rezidenturaVyhodnoceni == null) || (model?.rezidentura != "false")',
      },
      {
        type: 'tigger-button',
        className: 'p-col-12',
        props: {
          label: 'TPA.ResidentureBtn',
          translate: true,
          change: (field) => {
            field?.parent?.fieldGroup
              ?.find((p) => p.key == 'rezidenturaVyhodnoceni')
              ?.formControl?.patchValue(null);
            field?.parent?.fieldGroup
              ?.find((p) => p.key == 'studiumVCR')
              ?.formControl?.patchValue(null);
            field?.parent?.fieldGroup
              ?.find((p) => p.key == 'zdrzovaniVCR')
              ?.formControl?.patchValue(null);
            field?.parent?.fieldGroup
              ?.find((p) => p.key == 'rezidenturaVeState')
              ?.formControl?.patchValue(null);

            field?.parent?.fieldGroup
              ?.find((p) => p.key == 'rezidentura')
              ?.formControl?.patchValue(null);
          },
        },
        // Reset only resets auto-eval; in manual-fallback mode there's
        // nothing to reset, so hide it.
        hideExpression: (m, formState) =>
          m?.rezidentura == null ||
          (!!formState?.disablePersonalPart &&
            !!formState?.isResidencyDataMissing?.()),
      },
    ];
  }
}
